"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var border = 1;
var padding = 20;
var defaultMinWidth = 400;
var paddingWithBorder = 2 * (padding + border);

var columnMediaWidth = function columnMediaWidth(maxWidthValue) {
  return {
    '&> *': {
      maxWidth: maxWidthValue
    }
  };
};

var setBreakpoints = function setBreakpoints(breakpoints, minWidth) {
  var styles = {};
  var items = breakpoints.length;
  var width = "".concat(100 / (items + 2), "%");
  breakpoints.forEach(function (d, i) {
    var name = "@media (min-width: ".concat(d, "px) and (max-width: ").concat(d + minWidth - 1, "px)");
    styles[name] = columnMediaWidth("".concat(100 / (i + 2), "%"));
  });
  styles["@media (max-width: ".concat(2 * minWidth - 1, "px)")] = columnMediaWidth('100%');
  styles["@media (min-width: ".concat(breakpoints[items - 1] + minWidth, "px)")] = columnMediaWidth(width, width);
  return styles;
};

var makeStyle = function makeStyle(minWidth, columnsCount) {
  return function () {
    var minimalWidth = minWidth ? minWidth : defaultMinWidth;
    var breakpoints = (0, _immutable.Range)(minimalWidth * 2 + paddingWithBorder, minimalWidth * columnsCount + paddingWithBorder, minimalWidth).toArray();
    var data = setBreakpoints(breakpoints, minimalWidth);
    return {
      ColumnGrid: {
        display: 'flex',
        flex: '1',
        '-ms-flex-preferred-size': 'auto',
        '& .column': {
          'flex': '1',
          '-ms-flex-preferred-size': 'auto',
          'border-style': 'none none none solid',
          'border-width': border,
          'padding-left': padding,
          '&:first-child': {
            'border-left': 'none'
          }
        }
      },
      WrappedColumnGrid: _objectSpread(_objectSpread({}, data), {}, {
        flexDirection: 'row',
        flexWrap: 'wrap',
        '&> *': {
          minWidth: minimalWidth
        }
      })
    };
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map